import {ColDef} from "ag-grid-community";

export function columnDefs(): ColDef[] {

    return [
        {
            headerName: "Username",
            field: "email",
            filter: "agTextColumnFilter",
            resizable: true
        }, {
            headerName: "Source languages",
            field: "language_source",
            filter: "agTextColumnFilter",
            resizable: true
        }, {
            headerName: "Target languages",
            field: "language_target",
            filter: "agTextColumnFilter",
            resizable: true
        },
        {
            headerName: "Permission to confirm translations",
            cellRenderer(node){
              if (node.value == true) {
                  return "Yes"
              } else {
                  return "No"
              }
            },
            field: "approval",
            filter: "agTextColumnFilter",
            filterValueGetter: ((params) => {
                if (params.data.approval == true) {
                    return "Yes"
                } else {
                    return "No"
                }
            }),
            resizable: true
        }
    ] as ColDef[]
}
